import LinkButton from "@components/BoxListButton/components/LinkButton";
import { ActionButtonType } from "@enums/actionButtonType";
import { ArtistVerified } from "@enums/artistVerified";
import { categoryMap } from "@helpers/boxListButtonCategoryMap";
import { ReactElement } from "react";
import styles from "./BoxActionButtons.module.scss";
import ActionButton from "./components/ActionButton";

interface IBoxActionButtons {
  uuid: string;
  description: string;
  handleModal: Function;
  detailUrl: string;
  isVerified?: ArtistVerified;
  isBanned?: boolean;
  isFeatured?: boolean;
  isProject?: boolean;
}

const BoxActionButtons = ({
  uuid,
  description,
  handleModal,
  detailUrl,
  isVerified,
  isBanned,
  isFeatured,
  isProject = false,
}: IBoxActionButtons): ReactElement => (
  <div className={styles.boxActionButtons}>
    <LinkButton route={detailUrl} uuid={uuid} category={categoryMap.create} />

    <ActionButton
      uuid={uuid}
      description={description}
      category={categoryMap.ban}
      handleModal={handleModal}
      action={isBanned}
      type={ActionButtonType.Ban}
    />

    {!isProject && (
      <ActionButton
        uuid={uuid}
        description={description}
        category={categoryMap.verify}
        handleModal={handleModal}
        action={isVerified ?? ArtistVerified.NotVerified}
        type={ActionButtonType.Verify}
      />
    )}

    <ActionButton
      uuid={uuid}
      description={description}
      category={categoryMap.feature}
      handleModal={handleModal}
      action={isFeatured}
      type={ActionButtonType.Feature}
    />
  </div>
);

export default BoxActionButtons;
